import client from './http';

const config = {
  headers: {
    'Content-Type': 'application/json',
  },
};

// export const getPOData = () => { return Http.get('purchaseOrders') }
export const getSpecificPOData = (id, tabInfo) =>
  client.get(`pos/${id}/${tabInfo}`, config);
export const updatePOStatus = (id, statusInfo) => {
  const validJson = JSON.stringify(statusInfo);
  return client.patch(`pos/${id}/`, validJson, config);
};
export const updatePOSupplier = (id, info) => {
  const validJson = JSON.stringify(info);
  return client.post(`pos/${id}/setSupplier/`, validJson, config);
};
export const sendActiveTab = (id, activeTab) =>
  client.post(`pos/${id}/tabViewed/`, activeTab, config);
export const getSearchedPO = query => client.get(`pos/${query}`, config);
export const getCostumers = () => client.get('customers/?perPage=500', config);
export const setCustomer = name =>
  client.post('customers/', JSON.stringify(name), config);
export const getSuppliers = (query = '') =>
  client.get(`suppliers${query}`, config);



// WEBPACK FOOTER //
// ./src/services/purchase-orders.js